// Shared by the email/password form and "Continue with Google": what gets stored after a login, and where to go next.

const ALL_KEYS = [
  "access_token", "refresh_token", "token_type", "role", "username", "email", "user_id", "userId", "name", "surname",
  "student_id", "teacher_id", "currentSessionId", "activeConversation", "lastAgentSession", "agentContext", "theme",
  "language", "notifications", "lastUserId", "conversationHistory", "tempFormData", "redirectAfterLogin", "remember_me",
];

// Wipe everything left by a previous account so two people on one computer never see each other's data.
export function clearAuthData() {
  ALL_KEYS.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
  localStorage.clear();
  sessionStorage.clear();
}

// `data` is the "data" object of a successful /auth/login or /auth/google response.
export function storeAuthData(data, useLocalStorage) {
  const storage = useLocalStorage ? localStorage : sessionStorage;
  try {
    storage.setItem("access_token", data.access_token);
    storage.setItem("refresh_token", data.refresh_token);
    storage.setItem("token_type", data.token_type);
    storage.setItem("role", data.role);
    storage.setItem("username", data.username);
    storage.setItem("email", data.email);
    storage.setItem("remember_me", String(useLocalStorage));
    if (data.user_id) storage.setItem("user_id", data.user_id);
    if (data.student_id) storage.setItem("student_id", data.student_id);
    if (data.teacher_id) storage.setItem("teacher_id", data.teacher_id);
    if (data.name) storage.setItem("name", data.name);
    if (data.surname) storage.setItem("surname", data.surname);
    return true;
  } catch (err) {
    console.error("Failed to store auth data:", err);
    return false;
  }
}

export function getRedirectPath(role) {
  switch (role?.toLowerCase()) {
    case "student": return "/student-dashboard";
    case "teacher": return "/teacher-dashboard";
    case "admin": return "/admin-dashboard";
    default: return "/home";
  }
}
